import React, { FC } from 'react';
import styled from 'styled-components';
import { ContainerBase } from 'src/components/widgets/layouts';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2.5rem;
    align-items: start;
`;

const ListingBox = styled.div`
    border: 1px solid #dbe2e6;
    border-radius: 0.25rem;
    overflow: hidden;
`;

const ListingRow = styled.div`
    border-top: 1px solid #dbe2e6;
    padding: 0.5rem 0.75rem;

    &:first-child {
        border-top: none;
    }
`;

export const DamTagsPageSkeleton: FC = () => (
    <ContainerBase>
        <SkeletonStack $gap='10px' $margin='0 0 24px'>
            <SkeletonBlock $width='120px' $height='28px' />
            <SkeletonBlock $width='60%' $height='14px' />
        </SkeletonStack>
        <Grid>
            <SkeletonStack $gap='12px'>
                <SkeletonBlock $width='100px' $height='14px' />
                <SkeletonBlock $width='100%' $height='38px' />
                <SkeletonBlock $width='110px' $height='38px' $radius='6px' />
            </SkeletonStack>
            <ListingBox>
                <ListingRow>
                    <SkeletonBlock $width='90px' $height='14px' />
                </ListingRow>
                {Array.from({ length: 5 }).map((_, index) => (
                    <ListingRow key={index}>
                        <SkeletonBlock $width='40%' $height='14px' />
                    </ListingRow>
                ))}
            </ListingBox>
        </Grid>
    </ContainerBase>
);

export default DamTagsPageSkeleton;
